import { useCallback, useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useExportarDocumentosTurbo } from '@/services/Documentos';
import type { TipoExportacaoTurbo } from '@/services/Documentos';
import { useGerarLinkTemporario } from '@/services/General';
import { useDownloadNfseLote } from '@/services/ServicosNfse';
import type { DownloadNfseLoteFormato } from '@/services/ServicosNfse';
import { MODELOS_OPCOES } from '@/lib/utils/helpers';

type ColunaDisponivel = { id: string; label: string; grupo: string };

export const COLUNAS_DISPONIVEIS: ColunaDisponivel[] = [
  { id: 'Sequencial', label: 'Item', grupo: 'Básico' },
  { id: 'Produto', label: 'Código', grupo: 'Básico' },
  { id: 'Descricao', label: 'Descrição', grupo: 'Básico' },
  { id: 'EAN', label: 'EAN', grupo: 'Básico' },
  { id: 'NCM', label: 'NCM', grupo: 'Básico' },
  { id: 'CFOP', label: 'CFOP', grupo: 'Básico' },
  { id: 'CEST', label: 'CEST', grupo: 'Básico' },
  { id: 'Unidade', label: 'Unidade', grupo: 'Básico' },
  { id: 'Qtde', label: 'Quantidade', grupo: 'Básico' },
  { id: 'ValorUnitario', label: 'Valor Unit.', grupo: 'Básico' },
  { id: 'ValTot', label: 'Valor Total', grupo: 'Básico' },
  { id: 'CST', label: 'CST', grupo: 'ICMS' },
  { id: 'ICMS', label: 'Alíq. ICMS', grupo: 'ICMS' },
  { id: 'ValorICMS', label: 'Valor ICMS', grupo: 'ICMS' },
  { id: 'ValorBaseICMS', label: 'Base ICMS', grupo: 'ICMS' },
  { id: 'RedBC', label: 'Red. BC', grupo: 'ICMS' },
  { id: 'FCP', label: 'FCP', grupo: 'ICMS' },
  { id: 'ICMSUFDest', label: 'ICMS UF Dest', grupo: 'ICMS' },
  { id: 'ICMSST', label: 'Alíq. ICMS ST', grupo: 'ICMS ST' },
  { id: 'ValorICMSST', label: 'Valor ICMS ST', grupo: 'ICMS ST' },
  { id: 'ValorBaseICMSST', label: 'Base ICMS ST', grupo: 'ICMS ST' },
  { id: 'MVAST', label: 'MVA ST', grupo: 'ICMS ST' },
  { id: 'RedBCST', label: 'Red. BC ST', grupo: 'ICMS ST' },
  { id: 'FCPST', label: 'FCP ST', grupo: 'ICMS ST' },
  { id: 'CSTIpi', label: 'CST IPI', grupo: 'IPI' },
  { id: 'IPIAliq', label: 'Alíq. IPI', grupo: 'IPI' },
  { id: 'ValorIPI', label: 'Valor IPI', grupo: 'IPI' },
  { id: 'CSTPis', label: 'CST PIS', grupo: 'PIS' },
  { id: 'PISAliq', label: 'Alíq. PIS', grupo: 'PIS' },
  { id: 'ValorPIS', label: 'Valor PIS', grupo: 'PIS' },
  { id: 'VL_BC_PIS', label: 'Base PIS', grupo: 'PIS' },
  { id: 'CSTCofins', label: 'CST COFINS', grupo: 'COFINS' },
  { id: 'COFINSAliq', label: 'Alíq. COFINS', grupo: 'COFINS' },
  { id: 'ValorCOFINS', label: 'Valor COFINS', grupo: 'COFINS' },
  { id: 'VL_BC_COFINS', label: 'Base COFINS', grupo: 'COFINS' },
  { id: 'ValDesc', label: 'Desconto', grupo: 'Outros Valores' },
  { id: 'vRatAcr', label: 'Rat. Acréscimo', grupo: 'Outros Valores' },
  { id: 'vRatDesc', label: 'Rat. Desconto', grupo: 'Outros Valores' },
  { id: 'vFrete', label: 'Frete', grupo: 'Outros Valores' },
  { id: 'vSeg', label: 'Seguro', grupo: 'Outros Valores' },
  { id: 'vOUtro', label: 'Outros', grupo: 'Outros Valores' },
  { id: 'cBenef', label: 'Benefício Fiscal', grupo: 'Outros' },
  { id: 'cClassTrib', label: 'Classe Tributária', grupo: 'Reforma Tributária' },
  { id: 'vIBS', label: 'IBS', grupo: 'Reforma Tributária' },
  { id: 'vCBS', label: 'CBS', grupo: 'Reforma Tributária' },
  { id: 'vBC', label: 'vBC', grupo: 'Reforma Tributária' },
  { id: 'pIBSUF', label: 'pIBSUF', grupo: 'Reforma Tributária' },
  { id: 'vIBSUF', label: 'vIBSUF', grupo: 'Reforma Tributária' },
  { id: 'vBSMun', label: 'vBSMun', grupo: 'Reforma Tributária' },
  { id: 'pCBS', label: 'pCBS', grupo: 'Reforma Tributária' },
  { id: 'pDif', label: 'pDif', grupo: 'Reforma Tributária' },
  { id: 'vDif', label: 'vDif', grupo: 'Reforma Tributária' },
  { id: 'vDevTrib', label: 'vDevTrib', grupo: 'Reforma Tributária' },
  { id: 'pRedAliq', label: 'pRedAliq', grupo: 'Reforma Tributária' },
  { id: 'pAliqFet', label: 'pAliqFet', grupo: 'Reforma Tributária' },
  { id: 'cCredPres', label: 'cCredPres', grupo: 'Crédito Presumido' },
  { id: 'pCredPres', label: 'pCredPres', grupo: 'Crédito Presumido' },
  { id: 'vCredPres', label: 'vCredPres', grupo: 'Crédito Presumido' },
  { id: 'vCredPresCondSus', label: 'vCredPresCondSus', grupo: 'Crédito Presumido' },
  { id: 'vCredPresIBSZFM', label: 'vCredPresIBSZFM', grupo: 'Crédito Presumido' },
  { id: 'pAliqIBSUF', label: 'pAliqIBSUF', grupo: 'Alíquotas' },
  { id: 'vTribIBSUF', label: 'vTribIBSUF', grupo: 'Alíquotas' },
  { id: 'pAliqIBSMun', label: 'pAliqIBSMun', grupo: 'Alíquotas' },
  { id: 'vTribIBSMun', label: 'vTribIBSMun', grupo: 'Alíquotas' },
  { id: 'pAliqCBS', label: 'pAliqCBS', grupo: 'Alíquotas' },
  { id: 'vTribCBS', label: 'vTribCBS', grupo: 'Alíquotas' },
  { id: 'vIBSMun', label: 'vIBSMun', grupo: 'Monofásico' },
  { id: 'qBCMono', label: 'qBCMono', grupo: 'Monofásico' },
  { id: 'adRemIBS', label: 'adRemIBS', grupo: 'Monofásico' },
  { id: 'adRemCBS', label: 'adRemCBS', grupo: 'Monofásico' },
  { id: 'vIBSMono', label: 'vIBSMono', grupo: 'Monofásico' },
  { id: 'vCBSMono', label: 'vCBSMono', grupo: 'Monofásico' },
  { id: 'qBCMonoReten', label: 'qBCMonoReten', grupo: 'Monofásico Retenção' },
  { id: 'adRemIBSReten', label: 'adRemIBSReten', grupo: 'Monofásico Retenção' },
  { id: 'adRemCBSReten', label: 'adRemCBSReten', grupo: 'Monofásico Retenção' },
  { id: 'vIBSMonoReten', label: 'vIBSMonoReten', grupo: 'Monofásico Retenção' },
  { id: 'vCBSMonoReten', label: 'vCBSMonoReten', grupo: 'Monofásico Retenção' },
  { id: 'qBCMonoRet', label: 'qBCMonoRet', grupo: 'Monofásico Ret' },
  { id: 'adRemIBSRet', label: 'adRemIBSRet', grupo: 'Monofásico Ret' },
  { id: 'adRemCBSRet', label: 'adRemCBSRet', grupo: 'Monofásico Ret' },
  { id: 'vIBSMonoRet', label: 'vIBSMonoRet', grupo: 'Monofásico Ret' },
  { id: 'vCBSMonoRet', label: 'vCBSMonoRet', grupo: 'Monofásico Ret' },
  { id: 'pDifIBS', label: 'pDifIBS', grupo: 'Diferencial' },
  { id: 'vIBSMonoDif', label: 'vIBSMonoDif', grupo: 'Diferencial' },
  { id: 'pDifCBS', label: 'pDifCBS', grupo: 'Diferencial' },
  { id: 'vCBSMonoDif', label: 'vCBSMonoDif', grupo: 'Diferencial' },
  { id: 'vTotIBSMonof', label: 'vTotIBSMonof', grupo: 'Totais' },
  { id: 'vTotCBSMonof', label: 'vTotCBSMonof', grupo: 'Totais' },
  { id: 'vTransfCred', label: 'vTransfCred', grupo: 'Totais' },
  { id: 'CSTIS', label: 'CSTIS', grupo: 'IS' },
  { id: 'cClassTribIS', label: 'cClassTribIS', grupo: 'IS' },
  { id: 'vBCIS', label: 'vBCIS', grupo: 'IS' },
  { id: 'pIS', label: 'pIS', grupo: 'IS' },
  { id: 'pISEspec', label: 'pISEspec', grupo: 'IS' },
  { id: 'uTrib', label: 'uTrib', grupo: 'IS' },
  { id: 'qTrib', label: 'qTrib', grupo: 'IS' },
  { id: 'vIS', label: 'vIS', grupo: 'IS' },
  { id: 'CSTReg', label: 'CSTReg', grupo: 'Regime' },
  { id: 'cClassTribReg', label: 'cClassTribReg', grupo: 'Regime' },
  { id: 'pAliqFetRegIBSUF', label: 'pAliqFetRegIBSUF', grupo: 'Regime' },
  { id: 'vTribRegIBSUF', label: 'vTribRegIBSUF', grupo: 'Regime' },
  { id: 'pAliqFetRegIBSMun', label: 'pAliqFetRegIBSMun', grupo: 'Regime' },
  { id: 'vTribRegIBSMun', label: 'vTribRegIBSMun', grupo: 'Regime' },
  { id: 'pAliqFetRegCBS', label: 'pAliqFetRegCBS', grupo: 'Regime' },
  { id: 'vTribRegCBS', label: 'vTribRegCBS', grupo: 'Regime' },
  { id: 'DataExclusao', label: 'Data Exclusão', grupo: 'Outros' },
];

export const getModeloNome = (chaveAcesso: string): string => {
  if (!chaveAcesso || chaveAcesso.length < 21) return 'NF-e';
  const modelo = chaveAcesso.substring(20, 22);
  const modelos: Record<string, string> = {
    '13': 'NFS-e',
    '55': 'NF-e',
    '65': 'NFC-e',
    '57': 'CT-e',
    '62': 'NFCom',
    '66': 'NF3-e',
    '75': 'NFAg',
    '76': 'NFGas',
  };
  return modelos[modelo] || `Modelo ${modelo}`;
};

export const getModelo = (chaveAcesso: string): string => {
  if (!chaveAcesso || chaveAcesso.length < 21) return '55';
  return chaveAcesso.substring(20, 22);
};

/** Modelos com manifestação do destinatário na SEFAZ — mesmo conjunto do módulo Simples Nacional. */
export const MODELOS_COM_EVENTOS = new Set(['55', '65', '57']);

type ModeloKey = 'nfe' | 'nfc' | 'cte' | 'nfcom' | 'nf3e' | 'nfse' | 'nfag' | 'nfgas';

export const getModeloKey = (modelo: string): ModeloKey => {
  const map: Record<string, ModeloKey> = {
    '13': 'nfse',
    '55': 'nfe',
    '65': 'nfc',
    '57': 'cte',
    '62': 'nfcom',
    '66': 'nf3e',
    '75': 'nfag',
    '76': 'nfgas',
  };
  return map[modelo] || 'nfe';
};

/** NFC-e e SAT só existem como saída do contribuinte; a NFS-e tem módulo próprio (Serviços). */
export function modeloVisivelNasEntradas(modeloKey: string): boolean {
  return modeloKey !== 'nfc' && modeloKey !== 'sat' && modeloKey !== 'nfse';
}

/** NFCom, NF3-e, NFAg e NFGas só chegam como entrada; a NFS-e tem módulo próprio (Serviços). */
export function modeloVisivelNasSaidas(modeloKey: string, exibirSatSaidas: boolean): boolean {
  if (
    modeloKey === 'nfcom' ||
    modeloKey === 'nf3e' ||
    modeloKey === 'nfag' ||
    modeloKey === 'nfgas' ||
    modeloKey === 'nfse'
  ) {
    return false;
  }
  if (modeloKey === 'sat') return exibirSatSaidas;
  return true;
}

const MODELO_NFSE = '13';
const MODELO_NFGAS = '76';

/**
 * Os modelos de cada aba (SPEC-018, §1, decisão 3): nas Entradas, NF-e, CT-e, NFCom, NF3-e e NFGas; nas Saídas,
 * NF-e, NFC-e e CT-e; a NFS-e só no módulo de Serviços. O SAT não está na decisão 3: ele entra nas Saídas só em
 * período até 2025, porque a lista mostra o grupo SAT nesse período (exibeSatNoPeriodo) e todo modelo da lista filtra
 * pelo modelo (decisão 9).
 */
const MODELOS_DAS_ENTRADAS = ['55', '57', '62', '66', MODELO_NFGAS];
const MODELOS_DAS_SAIDAS = ['55', '65', '57'];
const MODELO_SAT = '59';

/** A lista das Saídas mostra o grupo SAT só quando o período termina até 2025. */
export function exibeSatNoPeriodo(dataFim: string | null | undefined): boolean {
  return !!dataFim && dataFim.slice(0, 10) <= '2025-12-31';
}

export function opcoesDeModelo(params: {
  tipoDocumento: '0' | '1';
  incluirNfse?: boolean;
  exibirSat?: boolean;
}) {
  const daAba =
    params.tipoDocumento === '0'
      ? MODELOS_DAS_ENTRADAS
      : [...MODELOS_DAS_SAIDAS, ...(params.exibirSat ? [MODELO_SAT] : [])];
  return MODELOS_OPCOES.filter(
    modelo => daAba.includes(modelo.value) || (!!params.incluirNfse && modelo.value === MODELO_NFSE)
  );
}

export interface OpcaoDaJanelaFiltros {
  value: string;
  label: string;
  /** O filtro em vigor que a aba não oferece: aparece no seletor, mas não se escolhe nesta aba. */
  foraDaAba: boolean;
}

/** Em que aba o modelo existe, para o rótulo do filtro em vigor que a aba aberta não oferece. */
function ondeOModeloExiste(modelo: string): string {
  if (modelo === MODELO_SAT) return 'só nas Saídas, até 2025';
  const nasEntradas = MODELOS_DAS_ENTRADAS.includes(modelo);
  const nasSaidas = MODELOS_DAS_SAIDAS.includes(modelo);
  if (nasEntradas && !nasSaidas) return 'só nas Entradas';
  if (nasSaidas && !nasEntradas) return 'só nas Saídas';
  return '';
}

/**
 * As opções de modelo da janela Filtros: as da aba (SPEC-018, §1, decisão 3), mais o filtro em vigor quando a aba não
 * o oferece (NF3-e escolhida nas Entradas e vista nas Saídas; o SAT depois de um período de 2026). O modelo vale para
 * as duas abas, e trocar de aba não o muda, nem aos quadros do topo (SPEC-003, §3, item 4). O filtro em vigor entra
 * desabilitado e com o rótulo de onde ele existe: o seletor mostra o filtro que vale, em vez de ficar em branco, e a
 * aba continua oferecendo para escolha só os modelos da decisão 3.
 */
export function opcoesDaJanelaFiltros(params: {
  tipoDocumento: '0' | '1';
  exibirSat?: boolean;
  modeloEmVigor?: string;
}): OpcaoDaJanelaFiltros[] {
  const daAba = opcoesDeModelo({
    tipoDocumento: params.tipoDocumento,
    exibirSat: params.exibirSat,
  }).map(opcao => ({ value: opcao.value, label: opcao.label, foraDaAba: false }));
  if (daAba.some(opcao => opcao.value === params.modeloEmVigor)) return daAba;

  const emVigor = MODELOS_OPCOES.find(opcao => opcao.value === params.modeloEmVigor);
  if (!emVigor) return daAba;

  const onde = ondeOModeloExiste(emVigor.value);
  return [
    ...daAba,
    {
      value: emVigor.value,
      label: onde ? `${emVigor.label} · em vigor, ${onde}` : `${emVigor.label} · em vigor`,
      foraDaAba: true,
    },
  ];
}

/** O modelo escolhido, se ele continua entre as opções do sentido; senão, nenhum. */
export function modeloDisponivel(
  modelo: string,
  params: { tipoDocumento: '0' | '1'; incluirNfse?: boolean; exibirSat?: boolean }
): string {
  return opcoesDeModelo(params).some(opcao => opcao.value === modelo) ? modelo : '';
}

export function paginarDocumentos<T>(documentos: T[], pagina: number, itensPorPagina: number): T[] {
  const inicio = (pagina - 1) * itensPorPagina;
  const fim = inicio + itensPorPagina;
  return documentos.slice(inicio, fim);
}

export const calcularTotalPaginas = (totalItens: number, itensPorPagina: number): number => {
  return Math.ceil(totalItens / itensPorPagina);
};

export const toggleColunaVisibilidade = (colunasAtuais: string[], colunaId: string): string[] => {
  return colunasAtuais.includes(colunaId)
    ? colunasAtuais.filter(id => id !== colunaId)
    : [...colunasAtuais, colunaId];
};

export const toggleGrupoColunas = (colunasAtuais: string[], grupo: string): string[] => {
  const colunasDoGrupo = COLUNAS_DISPONIVEIS.filter(c => c.grupo === grupo).map(c => c.id);
  const todasVisiveis = colunasDoGrupo.every(id => colunasAtuais.includes(id));

  if (todasVisiveis) {
    return colunasAtuais.filter(id => !colunasDoGrupo.includes(id));
  }
  return [...new Set([...colunasAtuais, ...colunasDoGrupo])];
};

export const criarPayloadItens = (params: {
  paginaAtual: number;
  itensPorPagina: number;
  dataInicio: string | null;
  dataFim: string | null;
  chaveAcesso: string;
  tipoDocumento: '0' | '1';
  modelo: string;
  cnpjContribuinte: string;
  cfop?: string;
  cst?: string;
  cest?: string;
  cclasstrib?: string;
  produtoCodigo?: string;
  produtoDescricao?: string;
  produtoEan?: string;
  produtoNcm?: string;
  dataEmissao?: string;
}) => ({
  pagina_numero: params.paginaAtual,
  pagina_quantidade_por: params.itensPorPagina,
  data_emissao_de: params.dataInicio || params.dataEmissao || '',
  data_emissao_ate: params.dataFim || params.dataEmissao || '',
  chave_acesso: params.chaveAcesso,
  entrada_saida: params.tipoDocumento,
  modelo_documento: params.modelo,
  CNPJ_Contribuinte: params.cnpjContribuinte,
  produto_codigo: params.produtoCodigo || undefined,
  produto_descricao: params.produtoDescricao || undefined,
  produto_ean: params.produtoEan || undefined,
  produto_ncm: params.produtoNcm || undefined,
  produto_lista_cfop: params.cfop ? [params.cfop] : [],
  cst: params.cst || undefined,
  cest: params.cest || undefined,
  cclasstrib: params.cclasstrib || undefined,
  exportacao: false,
});

export type TipoArquivoExportacao = 'excel' | 'pdf' | 'csv' | 'xml' | '';
export type TipoArquivoDownloadNfseLote = DownloadNfseLoteFormato | '';
export type ServicosDownloadNfseLote = '0' | '1' | 'ambos';

function iniciarDownload(url: string, nomeArquivo?: string) {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noreferrer';

  const filename = (nomeArquivo || '').split('/').pop();
  if (filename) {
    a.download = filename;
  }

  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Baixa o arquivo na mesma aba (SPEC-018, revisão). O link vem assinado com Content-Disposition de anexo
 * (`NomeArquivo` no GerarLinkTemporario), então o navegador baixa sem sair da tela. Uma aba nova aberta por clique
 * programado depois da espera da exportação é tratada como pop-up e pode ser bloqueada, com a tela dizendo que o
 * download começou. Com `nomeArquivo`, o link é baixado com esse nome: é o caso do arquivo montado na própria tela,
 * que não tem Content-Disposition e, sem o nome, seria aberto no lugar da tela.
 */
export function baixarComoAnexo(url: string, nomeArquivo?: string) {
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noreferrer';
  if (nomeArquivo) a.download = nomeArquivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * O XML da nota vira arquivo baixado na mesma aba (SPEC-018, §3, item 5). O conteúdo chega na resposta da API, que já
 * conferiu que a nota é do gestor; não há link assinado, nem bucket ou caminho vindo da tela.
 */
export function baixarXmlDaNota(xml: string, nomeArquivo: string) {
  const url = URL.createObjectURL(new Blob([xml], { type: 'application/xml;charset=utf-8' }));
  baixarComoAnexo(url, nomeArquivo);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

function base64ToBlob(base64: string, contentType: string) {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let index = 0; index < binaryString.length; index += 1) {
    bytes[index] = binaryString.charCodeAt(index);
  }

  return new Blob([bytes], { type: contentType });
}

export function useExportacaoDocumentosTurbo(params: {
  dataEmissaoDe: string;
  dataEmissaoAte: string;
  modeloDocumento: string;
  entradaSaida: '0' | '1';
  tipoArquivo: TipoArquivoExportacao;
  cnpjContribuinte?: string;
}) {
  const { toast } = useToast();
  const exportarTurbo = useExportarDocumentosTurbo();
  const gerarLink = useGerarLinkTemporario();

  // A falha fica para a janela mostrar, e não só no toast, que some em 5 s (sustentação de 26/10, item 4). Ela vale para
  // o pedido que falhou: trocar o modelo, o sentido, o período, o formato ou a empresa a tira da tela.
  const pedido = [
    params.dataEmissaoDe,
    params.dataEmissaoAte,
    params.modeloDocumento,
    params.entradaSaida,
    params.tipoArquivo,
    params.cnpjContribuinte ?? '',
  ].join('|');
  const [falha, setFalha] = useState<{ pedido: string; mensagem: string } | null>(null);
  const limparErro = useCallback(() => setFalha(null), []);

  const tipoExportacaoTurbo = (() => {
    if (params.tipoArquivo === 'pdf') return 'PDF';
    if (params.tipoArquivo === 'csv') return 'CSV';
    if (params.tipoArquivo === 'excel') return 'EXCEL';
    if (params.tipoArquivo === 'xml') return 'XML';
    return null;
  })() as TipoExportacaoTurbo | null;

  const isFormValid =
    !!tipoExportacaoTurbo &&
    !!params.modeloDocumento &&
    !!params.entradaSaida &&
    !!params.dataEmissaoDe &&
    !!params.dataEmissaoAte;

  const isPeriodoValido = (() => {
    if (!params.dataEmissaoDe || !params.dataEmissaoAte) return true;
    return params.dataEmissaoDe <= params.dataEmissaoAte;
  })();

  const isPending = exportarTurbo.isPending || gerarLink.isPending;

  const exportar = async (): Promise<boolean> => {
    if (!isFormValid || !isPeriodoValido || isPending) {
      return false;
    }

    setFalha(null);

    try {
      const exportResponse = await exportarTurbo.mutateAsync({
        data_emissao_de: params.dataEmissaoDe,
        data_emissao_ate: params.dataEmissaoAte,
        modelo_documento: params.modeloDocumento,
        entrada_saida: params.entradaSaida,
        tipo_exportacao: tipoExportacaoTurbo!,
        cnpj_contribuinte: params.cnpjContribuinte || undefined,
      });

      if (!exportResponse.status?.resultado) {
        throw new Error(
          exportResponse.status?.mensagem || 'Não foi possível exportar os documentos.'
        );
      }

      const bucket = exportResponse.data?.bucket;
      const nomeArquivo = exportResponse.data?.nomeArquivo;

      if (!bucket || !nomeArquivo) {
        throw new Error('Resposta da exportação inválida.');
      }

      const linkResponse = await gerarLink.mutateAsync({
        Funcao: 'GET',
        Bucket: bucket,
        Key: nomeArquivo,
        NomeArquivo: nomeArquivo.split('/').pop(),
      });

      if (!linkResponse.status?.resultado) {
        throw new Error(
          linkResponse.status?.mensagem || 'Não foi possível gerar o link temporário para download.'
        );
      }

      const urlDownload =
        typeof linkResponse.data === 'string' ? linkResponse.data : linkResponse.data?.url;
      if (!urlDownload) {
        throw new Error('Link de download não retornado pela API.');
      }

      baixarComoAnexo(urlDownload);
      toast({
        title: 'Exportação concluída',
        description: 'Os dados foram exportados e o download foi iniciado.',
      });

      return true;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Não foi possível exportar os documentos.';
      setFalha({ pedido, mensagem: message });
      toast({
        variant: 'destructive',
        title: 'Erro ao exportar',
        description: message,
      });
      return false;
    }
  };

  return {
    isFormValid,
    isPeriodoValido,
    isPending,
    exportar,
    /** A mensagem da última exportação que falhou, enquanto o pedido for o mesmo; senão, `null`. */
    erro: falha?.pedido === pedido ? falha.mensagem : null,
    limparErro,
  };
}

export function useDownloadEmLoteNfse(params: {
  dataEmissaoDe: string;
  dataEmissaoAte: string;
  tipoArquivo: TipoArquivoDownloadNfseLote;
  servicos: ServicosDownloadNfseLote;
  cnpjContribuinte?: string;
}) {
  const { toast } = useToast();
  const downloadLote = useDownloadNfseLote();
  const cnpjContribuinte = (params.cnpjContribuinte || '').replace(/\D/g, '');

  const isPeriodoValido = (() => {
    if (!params.dataEmissaoDe || !params.dataEmissaoAte) return true;
    return params.dataEmissaoDe <= params.dataEmissaoAte;
  })();

  const isFormValid =
    !!cnpjContribuinte && !!params.dataEmissaoDe && !!params.dataEmissaoAte && !!params.tipoArquivo;

  const exportar = async (): Promise<boolean> => {
    if (!isFormValid || !isPeriodoValido || downloadLote.isPending) {
      return false;
    }

    try {
      const response = await downloadLote.mutateAsync({
        cnpj_contribuinte: cnpjContribuinte,
        dataInicial: params.dataEmissaoDe,
        dataFinal: params.dataEmissaoAte,
        formato: params.tipoArquivo as DownloadNfseLoteFormato,
        entrada_saida: params.servicos === 'ambos' ? undefined : params.servicos,
      });

      const totalNaoEncontrados = response.totalNaoEncontrados ?? 0;

      if (response.totalArquivos === 0) {
        toast({
          variant: 'destructive',
          title: 'Nenhuma NFS-e para baixar',
          description:
            totalNaoEncontrados > 0
              ? `${totalNaoEncontrados} NFS-e do período estão sem arquivo XML armazenado.`
              : 'Nenhuma NFS-e encontrada para a empresa e o período informados.',
        });
        return false;
      }

      const nomeArquivo =
        response.nomeArquivo ||
        `nfse-lote-${params.tipoArquivo}-${params.dataEmissaoDe}-a-${params.dataEmissaoAte}.zip`;

      if (response.url) {
        iniciarDownload(response.url, nomeArquivo);
      } else if (response.zip) {
        const url = URL.createObjectURL(base64ToBlob(response.zip, 'application/zip'));
        iniciarDownload(url, nomeArquivo);
        window.setTimeout(() => URL.revokeObjectURL(url), 0);
      } else {
        throw new Error('Link de download não retornado pela API de download em lote.');
      }

      toast({
        title: 'Download concluído',
        description:
          totalNaoEncontrados > 0
            ? `${response.totalArquivos} NFS-e baixadas. ${totalNaoEncontrados} ficaram de fora por não terem arquivo XML armazenado.`
            : `${response.totalArquivos} NFS-e baixadas.`,
      });

      return true;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : 'Não foi possível baixar as NFS-e em lote.';
      toast({
        variant: 'destructive',
        title: 'Erro ao baixar NFS-e',
        description: message,
      });
      return false;
    }
  };

  return {
    isFormValid,
    isPeriodoValido,
    isPending: downloadLote.isPending,
    exportar,
  };
}
